import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { ServiceLogin } from "../../service/Login";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logo from '../../images/logotipo-ASL-Softhouse-azul.png';
import IconLogout from '../../images/Icons/Slot.svg';
import IconConfig from '../../images/Icons/icone-config.svg';
import addImage from '../../images/addImage.svg';
import addQrCode from '../../images/addQrCode.svg';
import IconUser from '../../images/Icons/UserRounded_black.svg';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { ColorPicker } from 'primereact/colorpicker';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ServiceApi } from "../../service/Api";
import { ServiceConfig } from "../../service/Config";

class ScreensConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            autorizado: false,
            carregando: true,

            UsuarioNome: '',
            showConfigModal: false,
            //configurações
            configuracaoSelecionada: 'login',
            configOriginal: null,
            //Config-login
            titulo: '',
            subtitulo: '',
            depoimentos: [],
            depoimentoAtual: {
                nome: '',
                cargo: '',
                texto: ''
            },
            currentDot: 0,
            imagens: [],
            currentImageDot: 0,
            QrCodeImage: '',
            QrCodeText: '',
            //endConfig-login
            //Config-Exames
            lblbtnViewer: '',
            lblbtnGaleria: '',
            lblbtnDownloadImagem: '',
            lblbtnDownloadVisualizador: '',
            lblbtnDownloadDicomZip: '',

            lblbtnVisualizarLaudo: '',
            lblbtnImprimirLaudo: '',
            lblbtnDownloadLaudo: '',
            lblbtnVisualizarAnexos: '',
            lblbtnVisualizarParecer: '',
            lblbtnCompartilhar: '',

            lblinfoAcNumber: '',
            lblinfoMedicoSol: '',
            lblinfoUnidade: '',
            lblinfoMedicoExe: '',
            lblinfoData: '',
            lblinfoMedicoRev: '',

            //endConfig-Exames
            //Config-Paciente
            exibirbtnViewerAvancado_Paciente: false,
            exibirbtnGaleria_Paciente: false,
            exibirbtnDownloadImagens_Paciente: false,

            exibirbtnVisualizarLaudo_Paciente: false,
            exibirbtnImprimirLaudo_Paciente: false,
            exibirbtnCompartilhar_Paciente: false,

            exibirbtnAnexos_Paciente: false,

            exibirInfoAcNumber_Paciente: false,
            exibirInfoProntuario_Paciente: false,
            exibirInfoData_Paciente: false,
            exibirInfoUnidade_Paciente: false,
            exibirInfoMedicoSol_Paciente: false,
            exbirInfoMedicoExe_Paciente: false,
            exibirInfoMedicoRev_Paciente: false,

            exibirbtnIncluirExames_Paciente: false,

            habilitarEnvioDICOM_ExamesExternos: false,

            pesquisa_Inicial_Exames_Paciente: 'Fixo',

            acaoBaixarImagens_visualizador_Paciente: false,
            acaoBaixarImagens_dicomZip_Paciente: false,

            acaoPrincipalbtnimagem_Paciente: '',

            acaoPrincipalPreview_Paciente: '',

            exibirStatus_Paciente: false,

            statusEmProcessamento_Paciente: '',
            statusAguardandoLaudo_Paciente: '',
            statusLaudoLiberado_Paciente: '',


            //endConfig-Paciente

            //Config-Medico
            exibirbtnViewerAvancado_Medico: false,
            exibirbtnGaleria_Medico: false,
            exibirbtnDownloadImagens_Medico: false,

            exibirbtnVisualizarLaudo_Medico: false,
            exibirbtnImprimirLaudo_Medico: false,
            exibirbtnCompartilhar_Medico: false,

            exibirbtnAnexos_Medico: false,

            exbibirbtnParecerMedico_Medico: false,

            acaoBaixarImagens_visualizador_Medico: false,
            acaoBaixarImagens_dicomZip_Medico: false,

            exibirInfoAcNumber_Medico: false,
            exibirInfoProntuario_Medico: false,
            exibirInfoData_Medico: false,
            exibirInfoUnidade_Medico: false,
            exibirInfoMedicoSol_Medico: false,
            exbirInfoMedicoExe_Medico: false,
            exibirInfoMedicoRev_Medico: false,

            exibirbtnIncluirExames_Medico: false,

            pesquisaExamesExternosAtiva_Medico: false,

            diasPesquisaInicialAoLogar_Medico: 0,

            acaoPrincipalbtnimagem_Viwer_Medico: false,
            acaoPrincipalbtnimagem_Galeria_Medico: true,

            exibirStatus_Medico: false,

            statusEmProcessamento_Medico: '',
            statusAguardandoLaudo_Medico: '',
            statusLaudoLiberado_Medico: '',

            acaoPrincipalPreview_Viwer_Medico: false,
            acaoPrincipalPreview_Galeria_Medico: true,
            //endConfig-Medico

            servicoDeImagem: '',
            servicoUsuario: '',
            servicoSenha: '',

            linkPortalProntuario: false,
            autenticacaoDoisFatores: false,

            formaDeEnvio: 0,
            criptografica: 0,
            tempoInatividade: 0,

            defaultColor: '#313852',
            secondaryColor: '#009CDE',

            SMTP: '',
            email: '',
            senha: '',
            porta: '',

            temSenha: '',

            validadeSenha: 0,

            conteudoEmail: "",
            mensagemNaoCadastrado: "",

            configDB: '',

            showSuccessModal: false,

            exibir_apenas_pedidos_revisados_portal: null

        };
    }

    async componentDidMount() {
        const dotCount = Math.min(this.state.depoimentos.length + 1, 5);
        const dots = Array.from({ length: dotCount }, (_, i) => i);

        try {
            await this.getConfig();
            await this.carregarConfig();
            this.alimentarComponentes();
        } catch (err) {
            console.error("Erro ao carregar:", err);
        }
    }


    carregarConfig = async () => {
        // Obtém o primeiro segmento do path dinamicamente:
        const getCandidateBases = () => {
            const parts = (window.location.pathname || "/")
                .split("/")
                .filter(Boolean);

            const bases = [];
            for (let i = parts.length; i >= 1; i--) {
                bases.push("/" + parts.slice(0, i).join("/"));
            }

            try {
                const params = new URLSearchParams(window.location.search);
                const override = params.get("basePath");
                if (override && override.startsWith("/") && override !== "/") {
                    bases.unshift(override.replace(/\/+$/, "")); // sem barra final
                }
            } catch { }

            const unique = [...new Set(bases.map(b => b.replace(/\/+$/, "")))];

            // Fallback opcional para raiz (APENAS PARA DESENVOLVIMENTO)
            // Basta comentar/descomentar a linha abaixo:
            //unique.push("");

            return unique;
        };

        const fetchWithTimeout = async (url, options = {}, ms = 7000) => {
            const controller = new AbortController();
            const id = setTimeout(() => controller.abort(), ms);
            try {
                return await fetch(url, { ...options, signal: controller.signal });
            } finally {
                clearTimeout(id);
            }
        };

        const applyConfigToState = (config) => {
            this.setState({
                config,
                configOriginal: JSON.parse(JSON.stringify(config)),
                titulo: config.login?.titulo || "",
                subtitulo: config.login?.subtitulo || "",
                depoimentos: config.depoimentos || [],
                depoimentoAtual: config.depoimentos?.length > 0
                    ? {
                        nome: config.depoimentos[0].nome,
                        cargo: config.depoimentos[0].cargo,
                        texto: config.depoimentos[0].texto
                    }
                    : { nome: "", cargo: "", texto: "" },
                imagens: config.carrosselImagens || [],
                QrCodeImage: config.qrCode?.imagem || "",
                QrCodeText: config.qrCode?.texto || ""
            });
        };

        try {
            const bases = getCandidateBases();
            if (bases.length === 0) {
                throw new Error("Nenhuma basePath candidata (app na raiz não é permitido).");
            }

            let lastError = null;
            for (const base of bases) {
                const prefix = base === "" ? "" : base;
                const url = `${prefix}/config.json?_=${Date.now()}`;

                try {
                    const res = await fetchWithTimeout(url, { cache: "no-store" });
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    const config = await res.json();
                    applyConfigToState(config);
                    return;
                } catch (err) {
                    console.warn(`[config] Falha em ${url}:`, err);
                    lastError = err;
                }
            }

            throw lastError || new Error("Arquivo config não foi encontrado");
        } catch (error) {
            console.error("Erro ao carregar config:", error);
        }
    };


    alimentarComponentes() {
        this.setState({

            //Ação principal BOTAO IMAGEM paciente:
            acaoPrincipalbtnimagem_Viwer_Paciente: this.state.acaoPrincipalbtnimagem_Paciente === 'Viewer',
            acaoPrincipalbtnimagem_Galeria_Paciente: this.state.acaoPrincipalbtnimagem_Paciente === 'Galeria',

            //Ação principal THUMBNAIL paciente:
            acaoPrincipalPreview_Viwer_Paciente: this.state.acaoPrincipalPreview_Paciente === 'Viewer',
            acaoPrincipalPreview_Galeria_Paciente: this.state.acaoPrincipalPreview_Paciente === 'Galeria'
        });
    }


    getConfig() {
        try {
            this.serviceConfig = new ServiceConfig();

            this.serviceConfig.GetConfig()
                .then(res => {
                    console.log("Resposta bruta:", res);

                    let arr = [];

                    if (Array.isArray(res.data)) {
                        arr = res.data;
                    } else if (Array.isArray(res)) {
                        arr = res;
                    } else if (typeof res.data === "string") {
                        arr = JSON.parse(res.data);
                    } else if (typeof res === "string") {
                        arr = JSON.parse(res);
                    } else {
                        console.error("Formato inesperado de resposta:", res);
                        return;
                    }

                    const config = {};
                    arr.forEach(item => {
                        config[item.Key] = {
                            id: item.Id,
                            value: item.Value
                        };
                    });

                    console.log("Config mapeada:", config);

   
                    this.setState({
                        configDB: config,
                        // Labels
                        lblbtnViewer: config['LABEL_BOTAO_VIEWER_PORTAL']?.value || '',
                        lblbtnGaleria: config['LABEL_BOTAO_GALERIA_PORTAL']?.value || '',
                        lblbtnDownloadImagem: config['LABEL_BOTAO_BAIXAR_DICOM_PORTAL']?.value || '',
                        lblbtnVisualizarLaudo: config['LABEL_BOTAO_LAUDO_PORTAL']?.value || '',
                        lblbtnImprimirLaudo: config['LABEL_BOTAO_IMPRIMIR_LAUDO_PORTAL']?.value || '',
                        lblbtnDownloadLaudo: config['LABEL_BOTAO_BAIXAR_LAUDO_PDF_PORTAL']?.value || '',
                        lblbtnVisualizarAnexos: config['LABEL_BOTAO_VISUALIZAR_ANEXOS_PORTAL']?.value || '',
                        lblbtnVisualizarParecer: config['LABEL_BOTAO_VISUALIZAR_PARECER_PORTAL']?.value || '',
                        lblbtnCompartilhar: config['LABEL_BOTAO_COMPARTILHAR_PORTAL']?.value || '',
                        lblbtnDownloadVisualizador: config['LABEL_BOTAO_BAIXAR_VISUALIZADOR']?.value || '',
                        lblbtnDownloadDicomZip: config['LABEL_BOTAO_BAIXAR_ZIP']?.value || '',                        
                        
                        lblinfoAcNumber: config['LABEL_INFO_ACENUMBER_PORTAL']?.value || '',
                        lblinfoUnidade: config['LABEL_INFO_UNIDADE_PORTAL']?.value || '',
                        lblinfoData: config['LABEL_INFO_DATA_PORTAL']?.value || '',
                        lblinfoMedicoSol: config['LABEL_INFO_MEDICO_SOLICITANTE_PORTAL']?.value || '',
                        lblinfoMedicoExe: config['LABEL_INFO_MEDICO_EXECUTANTE_PORTAL']?.value || '',
                        lblinfoMedicoRev: config['LABEL_INFO_MEDICO_REVISOR_PORTAL']?.value || '',

                        // Paciente
                        exibirbtnViewerAvancado_Paciente: config['BOTAO_VIEWER_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnGaleria_Paciente: config['BOTAO_GALERIA_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnDownloadImagens_Paciente: config['BOTAO_BAIXAR_IMAGENS_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnVisualizarLaudo_Paciente: config['BOTAO_LAUDO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnImprimirLaudo_Paciente: config['BOTAO_IMPRIMIR_LAUDO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnCompartilhar_Paciente: config['BOTAO_COMPARTILHAR_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnAnexos_Paciente: config['BOTAO_ANEXOS_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirbtnIncluirExames_Paciente: config['BOTAO_INCLUIR_EXAMES_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        habilitarEnvioDICOM_ExamesExternos: config['HABILITAR_ENVIO_DICOM_EXAMES_EXTERNOS']?.value === 'true',
                        pesquisa_Inicial_Exames_Paciente: config['PESQUISA_INICIAL_EXAMES_PACIENTE']?.value || 'Padrao',


                        acaoBaixarImagens_visualizador_Paciente: config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_PACIENTE']?.value === 'true',
                        acaoBaixarImagens_dicomZip_Paciente: config['ACAO_BAIXAR_IMAGENS_ZIP_PACIENTE']?.value === 'true',

                        exibirInfoAcNumber_Paciente: config['INFO_ACNUMBER_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirInfoProntuario_Paciente: config['INFO_PRONTUARIO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirInfoData_Paciente: config['INFO_DATA_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirInfoUnidade_Paciente: config['INFO_UNIDADE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirInfoMedicoSol_Paciente: config['INFO_MED_SOLICITANTE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exbirInfoMedicoExe_Paciente: config['INFO_MED_EXECUTANTE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        exibirInfoMedicoRev_Paciente: config['INFO_MED_REVISOR_ATIVO_PACIENTE_PORTAL']?.value === 'true',

                        acaoPrincipalbtnimagem_Paciente: config['ACAO_PRINCIPAL_BOTAO_IMAGENS_PACIENTE_PORTAL']?.value || 'Galeria',
                        acaoPrincipalPreview_Paciente: config['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_PACIENTE_PORTAL']?.value || 'Galeria',

                        exibirStatus_Paciente: config['STATUS_ATIVO_PACIENTE_PORTAL']?.value === 'true',
                        statusEmProcessamento_Paciente: config['LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL']?.value || '',
                        statusAguardandoLaudo_Paciente: config['LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL']?.value || '',
                        statusLaudoLiberado_Paciente: config['LABEL_STATUS_LIBERADO_PACIENTE_PORTAL']?.value || '',

                        // Médico
                        exibirbtnViewerAvancado_Medico: config['BOTAO_VIEWER_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnGaleria_Medico: config['BOTAO_GALERIA_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnDownloadImagens_Medico: config['BOTAO_BAIXAR_IMAGENS_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnVisualizarLaudo_Medico: config['BOTAO_LAUDO_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnImprimirLaudo_Medico: config['BOTAO_IMPRIMIR_LAUDO_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnCompartilhar_Medico: config['BOTAO_COMPARTILHAR_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnAnexos_Medico: config['BOTAO_ANEXOS_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exbibirbtnParecerMedico_Medico: config['BOTAO_PARECER_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirbtnIncluirExames_Medico: config['BOTAO_INCLUIR_EXAMES_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        pesquisaExamesExternosAtiva_Medico: config['PESQUISA_EXAMES_EXTERNOS_ATIVO_MEDICO']?.value === 'true',
                        diasPesquisaInicialAoLogar_Medico: parseInt(config['DIAS_PESQUISA_INICIAL_AO_LOGAR_MEDICO']?.value, 10) || 0,

                        acaoBaixarImagens_visualizador_Medico: config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_MEDICO']?.value === 'true',
                        acaoBaixarImagens_dicomZip_Medico: config['ACAO_BAIXAR_IMAGENS_ZIP_MEDICO']?.value === 'true',

                        exibirInfoAcNumber_Medico: config['INFO_ACNUMBER_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirInfoProntuario_Medico: config['INFO_PRONTUARIO_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirInfoData_Medico: config['INFO_DATA_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirInfoUnidade_Medico: config['INFO_UNIDADE_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirInfoMedicoSol_Medico: config['INFO_MED_SOLICITANTE_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exbirInfoMedicoExe_Medico: config['INFO_MED_EXECUTANTE_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        exibirInfoMedicoRev_Medico: config['INFO_MED_REVISOR_ATIVO_MEDICO_PORTAL']?.value === 'true',

                        acaoPrincipalbtnimagem_Medico: config['ACAO_PRINCIPAL_BOTAO_IMAGENS_MEDICO_PORTAL']?.value || 'Galeria',
                        acaoPrincipalPreview_Medico: config['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_MEDICO_PORTAL']?.value || 'Galeria',

                        exibirStatus_Medico: config['STATUS_ATIVO_MEDICO_PORTAL']?.value === 'true',
                        statusEmProcessamento_Medico: config['LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL']?.value || '',
                        statusAguardandoLaudo_Medico: config['LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL']?.value || '',
                        statusLaudoLiberado_Medico: config['LABEL_STATUS_LIBERADO_MEDICO_PORTAL']?.value || '',

                        servicoDeImagem: config['SERVICO_IMAGEM']?.value || '',

                        linkPortalProntuario: config['LOGIN_PORTAL_POR_PRONTUARIO']?.value === 'true',
                        autenticacaoDoisFatores: config['AUTENTICACAO_DOIS_FATORES']?.value === 'true',
                        
                        exibir_apenas_pedidos_revisados_portal: config["EXIBIR_APENAS_PEDIDOS_REVISADOS_PORTAL"]?.value === 'true',

                        formaDeEnvio: config['TIPO_ENVIO']?.value || 'EMAIL',
                        criptografica: config['CRIPTOGRAFIA_EMAIL']?.value || 'SSL',

                        SMTP: config['EMAIL_SMTP']?.value || '',
                        email: config['EMAIL_USUARIO']?.value || '',
                        senha: config['EMAIL_SENHA']?.value || '',
                        porta: config['EMAIL_PORTA']?.value || '',

                        validadeSenha: config['VALIDADE_SENHA']?.value || '24',

                        conteudoEmail: config['LAYOUT_EMAIL']?.value || '',
                        mensagemNaoCadastrado: config['MSG_EMAIL_NAO_CADASTRADO']?.value || '',

                        // Diversos
                        tempoInatividade: parseInt(config['TEMPO_INATIVIDADE_PORTAL']?.value || 0, 10)
                    });

                    if (this.state.senha && this.state.senha.trim() !== "") {
                        this.setState({
                            temSenha: "........"
                        });
                    }
                })
                .catch(err => console.error("Erro no GetConfig:", err));
        } catch (err) {
            console.error("Erro catch getConfig:", err);
        }


    }

    handleSalvarConfigDB = () => {
        const url = "Api/Portal/PostSalvarConfigDB";

        const configParaSalvar = [
            // Labels
            {
                Id: this.state.configDB['LABEL_BOTAO_VIEWER_PORTAL']?.id,
                Key: 'LABEL_BOTAO_VIEWER_PORTAL',
                Value: this.state.lblbtnViewer
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_GALERIA_PORTAL']?.id,
                Key: 'LABEL_BOTAO_GALERIA_PORTAL',
                Value: this.state.lblbtnGaleria
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_BAIXAR_DICOM_PORTAL']?.id,
                Key: 'LABEL_BOTAO_BAIXAR_DICOM_PORTAL',
                Value: this.state.lblbtnDownloadImagem
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_LAUDO_PORTAL']?.id,
                Key: 'LABEL_BOTAO_LAUDO_PORTAL',
                Value: this.state.lblbtnVisualizarLaudo
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_IMPRIMIR_LAUDO_PORTAL']?.id,
                Key: 'LABEL_BOTAO_IMPRIMIR_LAUDO_PORTAL',
                Value: this.state.lblbtnImprimirLaudo
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_BAIXAR_LAUDO_PDF_PORTAL']?.id,
                Key: 'LABEL_BOTAO_BAIXAR_LAUDO_PDF_PORTAL',
                Value: this.state.lblbtnDownloadLaudo
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_VISUALIZAR_ANEXOS_PORTAL']?.id,
                Key: 'LABEL_BOTAO_VISUALIZAR_ANEXOS_PORTAL',
                Value: this.state.lblbtnVisualizarAnexos
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_VISUALIZAR_PARECER_PORTAL']?.id,
                Key: 'LABEL_BOTAO_VISUALIZAR_PARECER_PORTAL',
                Value: this.state.lblbtnVisualizarParecer
            },
            {
                Id: this.state.configDB['LABEL_BOTAO_COMPARTILHAR_PORTAL']?.id,
                Key: 'LABEL_BOTAO_COMPARTILHAR_PORTAL',
                Value: this.state.lblbtnCompartilhar
            },

            {
                Id: this.state.configDB['LABEL_BOTAO_BAIXAR_VISUALIZADOR']?.id,
                Key: 'LABEL_BOTAO_BAIXAR_VISUALIZADOR',
                Value: this.state.lblbtnDownloadVisualizador
            },

            {
                Id: this.state.configDB['LABEL_BOTAO_BAIXAR_ZIP']?.id,
                Key: 'LABEL_BOTAO_BAIXAR_ZIP',
                Value: this.state.lblbtnDownloadDicomZip
            },   

            // Infos
            {
                Id: this.state.configDB['LABEL_INFO_ACENUMBER_PORTAL']?.id,
                Key: 'LABEL_INFO_ACENUMBER_PORTAL',
                Value: this.state.lblinfoAcNumber
            },
            {
                Id: this.state.configDB['LABEL_INFO_UNIDADE_PORTAL']?.id,
                Key: 'LABEL_INFO_UNIDADE_PORTAL',
                Value: this.state.lblinfoUnidade
            },
            {
                Id: this.state.configDB['LABEL_INFO_DATA_PORTAL']?.id,
                Key: 'LABEL_INFO_DATA_PORTAL',
                Value: this.state.lblinfoData
            },
            {
                Id: this.state.configDB['LABEL_INFO_MEDICO_SOLICITANTE_PORTAL']?.id,
                Key: 'LABEL_INFO_MEDICO_SOLICITANTE_PORTAL',
                Value: this.state.lblinfoMedicoSol
            },
            {
                Id: this.state.configDB['LABEL_INFO_MEDICO_EXECUTANTE_PORTAL']?.id,
                Key: 'LABEL_INFO_MEDICO_EXECUTANTE_PORTAL',
                Value: this.state.lblinfoMedicoExe
            },
            {
                Id: this.state.configDB['LABEL_INFO_MEDICO_REVISOR_PORTAL']?.id,
                Key: 'LABEL_INFO_MEDICO_REVISOR_PORTAL',
                Value: this.state.lblinfoMedicoRev
            },

            // Status paciente
            {
                Id: this.state.configDB['LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL',
                Value: this.state.statusEmProcessamento_Paciente
            },
            {
                Id: this.state.configDB['LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL',
                Value: this.state.statusAguardandoLaudo_Paciente
            },
            {
                Id: this.state.configDB['LABEL_STATUS_LIBERADO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_LIBERADO_PACIENTE_PORTAL',
                Value: this.state.statusLaudoLiberado_Paciente
            },

            // Status médico
            {
                Id: this.state.configDB['LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL',
                Value: this.state.statusEmProcessamento_Medico
            },
            {
                Id: this.state.configDB['LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL',
                Value: this.state.statusAguardandoLaudo_Medico
            },
            {
                Id: this.state.configDB['LABEL_STATUS_LIBERADO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_LIBERADO_MEDICO_PORTAL',
                Value: this.state.statusLaudoLiberado_Medico
            },

            // Diversos
            {
                Id: this.state.configDB['SERVICO_IMAGEM']?.id,
                Key: 'SERVICO_IMAGEM',
                Value: this.state.servicoDeImagem
            },
            {
                Id: this.state.configDB['LOGIN_PORTAL_POR_PRONTUARIO']?.id,
                Key: 'LOGIN_PORTAL_POR_PRONTUARIO',
                Value: this.state.linkPortalProntuario ? 'true' : 'false'
            },
            {
                Id: this.state.configDB['AUTENTICACAO_DOIS_FATORES']?.id,
                Key: 'AUTENTICACAO_DOIS_FATORES',
                Value: this.state.autenticacaoDoisFatores ? 'true' : 'false'
            },
            {
                Id: this.state.configDB['EXIBIR_APENAS_PEDIDOS_REVISADOS_PORTAL']?.id,
                Key: 'EXIBIR_APENAS_PEDIDOS_REVISADOS_PORTAL',
                Value: this.state.exibir_apenas_pedidos_revisados_portal ? 'true' : 'false'
            },
            {
                Id: this.state.configDB['TIPO_ENVIO']?.id,
                Key: 'TIPO_ENVIO',
                Value: this.state.formaDeEnvio
            },
            {
                Id: this.state.configDB['CRIPTOGRAFIA_EMAIL']?.id,
                Key: 'CRIPTOGRAFIA_EMAIL',
                Value: this.state.criptografica
            },
            {
                Id: this.state.configDB['EMAIL_SMTP']?.id,
                Key: 'EMAIL_SMTP',
                Value: this.state.SMTP
            },
            {
                Id: this.state.configDB['EMAIL_USUARIO']?.id,
                Key: 'EMAIL_USUARIO',
                Value: this.state.email
            },
            {
                Id: this.state.configDB['EMAIL_SENHA']?.id,
                Key: 'EMAIL_SENHA',
                Value: this.state.senha
            },
            {
                Id: this.state.configDB['EMAIL_PORTA']?.id,
                Key: 'EMAIL_PORTA',
                Value: this.state.porta
            },
            {
                Id: this.state.configDB['VALIDADE_SENHA']?.id,
                Key: 'VALIDADE_SENHA',
                Value: this.state.validadeSenha
            },
            {
                Id: this.state.configDB['LAYOUT_EMAIL']?.id,
                Key: 'LAYOUT_EMAIL',
                Value: this.state.conteudoEmail.toString()
            },
            {
                Id: this.state.configDB['MSG_EMAIL_NAO_CADASTRADO']?.id,
                Key: 'MSG_EMAIL_NAO_CADASTRADO',
                Value: this.state.mensagemNaoCadastrado.toString()
            },
            {
                Id: this.state.configDB['TEMPO_INATIVIDADE_PORTAL']?.id,
                Key: 'TEMPO_INATIVIDADE_PORTAL',
                Value: this.state.tempoInatividade.toString()
            },


            //PACIENTE

            {
                Id: this.state.configDB['BOTAO_VIEWER_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_VIEWER_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnViewerAvancado_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_GALERIA_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_GALERIA_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnGaleria_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_BAIXAR_IMAGENS_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_BAIXAR_IMAGENS_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnDownloadImagens_Paciente
            },

            {
                Id: this.state.configDB['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_PACIENTE']?.id,
                Key: 'ACAO_BAIXAR_IMAGENS_VISUALIZADOR_PACIENTE',
                Value: this.state.acaoBaixarImagens_visualizador_Paciente
            },

            {
                Id: this.state.configDB['ACAO_BAIXAR_IMAGENS_ZIP_PACIENTE']?.id,
                Key: 'ACAO_BAIXAR_IMAGENS_ZIP_PACIENTE',
                Value: this.state.acaoBaixarImagens_dicomZip_Paciente
            },



            {
                Id: this.state.configDB['BOTAO_LAUDO_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_LAUDO_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnVisualizarLaudo_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_IMPRIMIR_LAUDO_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_IMPRIMIR_LAUDO_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnImprimirLaudo_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_COMPARTILHAR_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_COMPARTILHAR_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnCompartilhar_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_ANEXOS_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_ANEXOS_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnAnexos_Paciente
            },

            {
                Id: this.state.configDB['INFO_ACNUMBER_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_ACNUMBER_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoAcNumber_Paciente
            },

            {
                Id: this.state.configDB['INFO_PRONTUARIO_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_PRONTUARIO_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoProntuario_Paciente
            },

            {
                Id: this.state.configDB['INFO_DATA_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_DATA_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoData_Paciente
            },

            {
                Id: this.state.configDB['INFO_UNIDADE_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_UNIDADE_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoUnidade_Paciente
            },

            {
                Id: this.state.configDB['INFO_MED_SOLICITANTE_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_MED_SOLICITANTE_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoMedicoSol_Paciente
            },

            {
                Id: this.state.configDB['INFO_MED_EXECUTANTE_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_MED_EXECUTANTE_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exbirInfoMedicoExe_Paciente
            }, 

            {
                Id: this.state.configDB['INFO_MED_REVISOR_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'INFO_MED_REVISOR_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirInfoMedicoRev_Paciente
            },

            {
                Id: this.state.configDB['BOTAO_INCLUIR_EXAMES_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'BOTAO_INCLUIR_EXAMES_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirbtnIncluirExames_Paciente
            },
            {
                Id: this.state.configDB['PESQUISA_INICIAL_EXAMES_PACIENTE']?.id,
                Key: 'PESQUISA_INICIAL_EXAMES_PACIENTE',
                Value: this.state.pesquisa_Inicial_Exames_Paciente
            },

            {
                Id: this.state.configDB['HABILITAR_ENVIO_DICOM_EXAMES_EXTERNOS']?.id,
                Key: 'HABILITAR_ENVIO_DICOM_EXAMES_EXTERNOS',
                Value: this.state.habilitarEnvioDICOM_ExamesExternos
            },

            {
                Id: this.state.configDB['ACAO_PRINCIPAL_BOTAO_IMAGENS_PACIENTE_PORTAL']?.id,
                Key: 'ACAO_PRINCIPAL_BOTAO_IMAGENS_PACIENTE_PORTAL',
                Value: this.state.acaoPrincipalbtnimagem_Paciente
            },

            {
                Id: this.state.configDB['LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL',
                Value: this.state.statusEmProcessamento_Paciente
            },

            {
                Id: this.state.configDB['LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL',
                Value: this.state.statusAguardandoLaudo_Paciente
            },

            {
                Id: this.state.configDB['LABEL_STATUS_LIBERADO_PACIENTE_PORTAL']?.id,
                Key: 'LABEL_STATUS_LIBERADO_PACIENTE_PORTAL',
                Value: this.state.statusLaudoLiberado_Paciente
            }, 

            {
                Id: this.state.configDB['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_PACIENTE_PORTAL']?.id,
                Key: 'ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_PACIENTE_PORTAL',
                Value: this.state.acaoPrincipalPreview_Paciente
            },

            {
                Id: this.state.configDB['STATUS_ATIVO_PACIENTE_PORTAL']?.id,
                Key: 'STATUS_ATIVO_PACIENTE_PORTAL',
                Value: this.state.exibirStatus_Paciente
            },

            //MEDICO

            {
                Id: this.state.configDB['BOTAO_VIEWER_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_VIEWER_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnViewerAvancado_Medico
            },

            {
                Id: this.state.configDB['BOTAO_GALERIA_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_GALERIA_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnGaleria_Medico
            },

            {
                Id: this.state.configDB['BOTAO_BAIXAR_IMAGENS_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_BAIXAR_IMAGENS_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnDownloadImagens_Medico
            },

            {
                Id: this.state.configDB['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_MEDICO']?.id,
                Key: 'ACAO_BAIXAR_IMAGENS_VISUALIZADOR_MEDICO',
                Value: this.state.acaoBaixarImagens_visualizador_Medico
            },

            {
                Id: this.state.configDB['ACAO_BAIXAR_IMAGENS_ZIP_MEDICO']?.id,
                Key: 'ACAO_BAIXAR_IMAGENS_ZIP_MEDICO',
                Value: this.state.acaoBaixarImagens_dicomZip_Medico
            },

            {
                Id: this.state.configDB['BOTAO_LAUDO_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_LAUDO_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnVisualizarLaudo_Medico
            },

            {
                Id: this.state.configDB['BOTAO_IMPRIMIR_LAUDO_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_IMPRIMIR_LAUDO_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnImprimirLaudo_Medico
            },

            {
                Id: this.state.configDB['BOTAO_COMPARTILHAR_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_COMPARTILHAR_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnCompartilhar_Medico
            },

            {
                Id: this.state.configDB['BOTAO_ANEXOS_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_ANEXOS_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnAnexos_Medico
            },

            {
                Id: this.state.configDB['BOTAO_PARECER_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_PARECER_ATIVO_MEDICO_PORTAL',
                Value: this.state.exbibirbtnParecerMedico_Medico
            },

            {
                Id: this.state.configDB['INFO_ACNUMBER_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_ACNUMBER_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoAcNumber_Medico
            },

            {
                Id: this.state.configDB['INFO_PRONTUARIO_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_PRONTUARIO_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoProntuario_Medico
            },

            {
                Id: this.state.configDB['INFO_DATA_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_DATA_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoData_Medico
            },

            {
                Id: this.state.configDB['INFO_UNIDADE_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_UNIDADE_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoUnidade_Medico
            },

            {
                Id: this.state.configDB['INFO_MED_SOLICITANTE_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_MED_SOLICITANTE_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoMedicoSol_Medico
            },

            {
                Id: this.state.configDB['INFO_MED_EXECUTANTE_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_MED_EXECUTANTE_ATIVO_MEDICO_PORTAL',
                Value: this.state.exbirInfoMedicoExe_Medico
            },

            {
                Id: this.state.configDB['INFO_MED_REVISOR_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'INFO_MED_REVISOR_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirInfoMedicoRev_Medico
            },

            {
                Id: this.state.configDB['BOTAO_INCLUIR_EXAMES_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'BOTAO_INCLUIR_EXAMES_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirbtnIncluirExames_Medico
            },

            {
                Id: this.state.configDB['PESQUISA_EXAMES_EXTERNOS_ATIVO_MEDICO']?.id,
                Key: 'PESQUISA_EXAMES_EXTERNOS_ATIVO_MEDICO',
                Value: this.state.pesquisaExamesExternosAtiva_Medico
            },

            {
                Id: this.state.configDB['DIAS_PESQUISA_INICIAL_AO_LOGAR_MEDICO']?.id,
                Key: 'DIAS_PESQUISA_INICIAL_AO_LOGAR_MEDICO',
                Value: this.state.diasPesquisaInicialAoLogar_Medico?.toString()
            },

            {
                Id: this.state.configDB['ACAO_PRINCIPAL_BOTAO_IMAGENS_MEDICO_PORTAL']?.id,
                Key: 'ACAO_PRINCIPAL_BOTAO_IMAGENS_MEDICO_PORTAL',
                Value: this.state.acaoPrincipalbtnimagem_Medico
            },

            {
                Id: this.state.configDB['LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL',
                Value: this.state.statusEmProcessamento_Medico
            },

            {
                Id: this.state.configDB['LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL',
                Value: this.state.statusAguardandoLaudo_Medico
            },

            {
                Id: this.state.configDB['LABEL_STATUS_LIBERADO_MEDICO_PORTAL']?.id,
                Key: 'LABEL_STATUS_LIBERADO_MEDICO_PORTAL',
                Value: this.state.statusLaudoLiberado_Medico
            },

            {
                Id: this.state.configDB['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_MEDICO_PORTAL']?.id,
                Key: 'ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_MEDICO_PORTAL',
                Value: this.state.acaoPrincipalPreview_Medico
            },

            {
                Id: this.state.configDB['STATUS_ATIVO_MEDICO_PORTAL']?.id,
                Key: 'STATUS_ATIVO_MEDICO_PORTAL',
                Value: this.state.exibirStatus_Medico
            },

        ];

        ServiceApi.post(url, configParaSalvar)
            .then(res => {
                console.log("Config DB salva com sucesso!", res);
            })
            .catch(err => console.error("Erro ao salvar no DB:", err));
    };

    handleIncluirTestimonial = () => {
        const { depoimentoAtual, depoimentos, currentDot } = this.state;

        if (
            !depoimentoAtual.nome?.trim() ||
            !depoimentoAtual.cargo?.trim() ||
            !depoimentoAtual.texto?.trim()
        ) {
            return; // evita salvar se estiver vazio
        }

        const novosDepoimentos = [...depoimentos];
        novosDepoimentos[currentDot] = { ...depoimentoAtual };

        if (novosDepoimentos.length > 5) novosDepoimentos.length = 5;

        this.setState({ depoimentos: novosDepoimentos });
    };

    handleExcluirTestimonial = () => {
        const novos = [...this.state.depoimentos]; // ✅ agora sim, usamos antes

        if (novos.length === 0) {
            this.setState({
                depoimentos: [],
                currentDot: 0,
                depoimentoAtual: { texto: '', nome: '', cargo: '' }
            });
            return;
        }

        novos.splice(this.state.currentDot, 1);

        const novoIndex = this.state.currentDot > 0 ? this.state.currentDot - 1 : 0;
        const novoAtual = novos[novoIndex] || { texto: '', nome: '', cargo: '' };

        this.setState({
            depoimentos: novos,
            currentDot: novoIndex,
            depoimentoAtual: novoAtual
        });
    };

    handleUploadImagem = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            const novas = [...this.state.imagens];
            novas[this.state.currentImageDot] = reader.result;
            this.setState({
                imagens: novas,
            });
        };
        reader.readAsDataURL(file);
    };

    handleDropImagem = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = () => {
                const novas = [...this.state.imagens];
                novas[this.state.currentImageDot] = reader.result;
                this.setState({ imagens: novas });
            };
            reader.readAsDataURL(file);
        }
    };

    handleRemoverImagem = () => {
        const novas = [...this.state.imagens];
        novas.splice(this.state.currentImageDot, 1);

        const novoIndex = this.state.currentImageDot > 0
            ? this.state.currentImageDot - 1
            : 0;

        this.setState({
            imagens: novas,
            currentImageDot: novoIndex,
        });
    };

    handleDropQrCode = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = () => {
                const novas = [...this.state.QrCodeImage];
                novas[this.state.currentQrCodeImage] = reader.result;
                this.setState({ QrCodeImage: novas });
            };
            reader.readAsDataURL(file);
        }
    };

    handleUploadQrCode = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            this.setState({
                QrCodeImage: reader.result
            });
        };
        reader.readAsDataURL(file);
    };

    handleRemoverQrCode = () => {
        this.setState({
            QrCodeImage: ''
        });
    };

    handleSalvarConfig() {
        const url = "Api/Portal/PostSalvarConfig";

        // Monta o novo objeto de config com os valores atualizados do state
        const configAtualizado = {
            ...this.state.config, // mantém os campos que você não alterou no modal
            login: {
                titulo: this.state.titulo,
                subtitulo: this.state.subtitulo
            },
            depoimentos: this.state.depoimentos,
            carrosselImagens: this.state.imagens,
            qrCode: {
                imagem: this.state.QrCodeImage,
                texto: this.state.QrCodeText
            },
            tema: {
                corPrimaria: this.state.config?.tema?.corPrimaria || "#313852",
                corSecundaria: this.state.config?.tema?.corSecundaria || "#009CDE"
            },
            configPath: this.state.config?.configPath // mantém o caminho físico
        };

        // Atualiza o state.config antes de enviar
        this.setState({ config: configAtualizado }, () => {
            ServiceApi.post(url, this.state.config)
                .then(res => {
                    if (res) {
                        console.log("Configuração salva com sucesso!", res);
                    } else {
                        console.error("Erro ao salvar configuração.");
                    }
                })
                .catch(ex => {
                    console.error("Falha ao salvar configuração:", ex);
                });
        });
    }



    // dentro da sua classe
    onBtnMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        e.currentTarget.style.setProperty('--x', `${x}px`);
        e.currentTarget.style.setProperty('--y', `${y}px`);
    };

    updateDepoimentoAtual = (campo, valor) => {
        this.setState((prev) => {
            const depoimentos = [...prev.depoimentos];

            // se já existe um depoimento nesse índice, atualiza
            if (depoimentos[prev.currentDot]) {
                depoimentos[prev.currentDot] = {
                    ...depoimentos[prev.currentDot],
                    [campo]: valor
                };
            }

            return {
                depoimentoAtual: {
                    ...prev.depoimentoAtual,
                    [campo]: valor
                },
                depoimentos
            };
        });
    };


    renderConfigHeader() {
        return (
            <div className="config-modal--navigation">
                <button
                    className={`config-modal__navigation-button ${this.state.configuracaoSelecionada === 'login'
                        ? 'config-modal__navigation-button-selected'
                        : ''
                        }`}
                    onMouseMove={this.onBtnMove}
                    onClick={() =>
                        this.setState({ configuracaoSelecionada: 'login' })
                    }
                >
                    <span>Login</span>
                </button>
                <button
                    className={`config-modal__navigation-button ${this.state.configuracaoSelecionada === 'exames'
                        ? 'config-modal__navigation-button-selected'
                        : ''
                        }`}
                    onMouseMove={this.onBtnMove}
                    onClick={() =>
                        this.setState({ configuracaoSelecionada: 'exames' })
                    }
                >
                    <span>Exames</span>
                </button>

                <button
                    className={`config-modal__navigation-button ${this.state.configuracaoSelecionada === 'paciente'
                        ? 'config-modal__navigation-button-selected'
                        : ''
                        }`}
                    onMouseMove={this.onBtnMove}
                    onClick={() =>
                        this.setState({ configuracaoSelecionada: 'paciente' })
                    }
                >
                    <span>Paciente</span>
                </button>

                <button
                    className={`config-modal__navigation-button ${this.state.configuracaoSelecionada === 'medico'
                        ? 'config-modal__navigation-button-selected'
                        : ''
                        }`}
                    onMouseMove={this.onBtnMove}
                    onClick={() =>
                        this.setState({ configuracaoSelecionada: 'medico' })
                    }
                >
                    <span>Médico</span>
                </button>

                <button
                    className={`config-modal__navigation-button ${this.state.configuracaoSelecionada === 'geral'
                        ? 'config-modal__navigation-button-selected'
                        : ''
                        }`}
                    onMouseMove={this.onBtnMove}
                    onClick={() =>
                        this.setState({ configuracaoSelecionada: 'geral' })
                    }
                >
                    <span>Geral</span>
                </button>
            </div>
        )
    }

    renderConfigLogin() {

        const dotCount = Math.min(this.state.depoimentos.length + 1, 5); // no máximo 5
        const dots = Array.from({ length: dotCount }, (_, i) => i);

        return (
            <div className="config-modal--login">
                <div className="config-modal--login-left" >
                    <div className="config-modal--input">
                        <label className="config-modal--label">Título</label>
                        <InputText
                            className="config-modal--input-text-titulo"
                            placeholder="Escreva o título que aparecerá na tela de login"
                            value={this.state.titulo}
                            onChange={(e) =>
                                this.setState({
                                    titulo: e.target.value
                                })
                            }
                        />
                    </div>
                    <div className="config-modal--input">
                        <label className="config-modal--label">Subtítulo</label>
                        <InputTextarea
                            className="config-modal--input-text-subtitulo"
                            placeholder="Escreva o texto que aparecerá abaixo do título"
                            value={this.state.subtitulo}
                            onChange={(e) =>
                                this.setState({
                                    subtitulo: e.target.value
                                })
                            }
                            autoResize={true}
                        />
                    </div>

                    <div className="config-modal--testimonial-form">
                        {/* Campo de texto do depoimento */}
                        <div className="config-modal--input">
                            <label className="config-modal--label">Depoimento</label>
                            <InputTextarea
                                className="config-modal--input-text-testimonial"
                                placeholder="Escreva o depoimento aqui"
                                value={this.state.depoimentoAtual?.texto || ""}
                                onChange={(e) => this.updateDepoimentoAtual("texto", e.target.value)}
                                autoResize={true}
                            />
                        </div>

                        <div className="form-inline">
                            <label className="config-modal--label">Cargo</label>
                            <InputText
                                className="config-modal--input-text-role"
                                placeholder="Ex: Cardiologista"
                                value={this.state.depoimentoAtual?.cargo || ""}
                                onChange={(e) => this.updateDepoimentoAtual("cargo", e.target.value)}
                            />

                            <label className="config-modal--label">Nome</label>
                            <InputText
                                className="config-modal--input-text-name"
                                placeholder="Ex: Dra. Fernanda"
                                value={this.state.depoimentoAtual?.nome || ""}
                                onChange={(e) => this.updateDepoimentoAtual("nome", e.target.value)}
                            />

                            {this.state.depoimentos[this.state.currentDot] ? (
                                <button
                                    className="config-modal--testimonial-button-excluir"
                                    onClick={this.handleExcluirTestimonial}
                                >
                                    Excluir
                                </button>
                            ) : (
                                <button
                                    className="config-modal--testimonial-button"
                                    onClick={this.handleIncluirTestimonial}
                                >
                                    Incluir
                                </button>
                            )}
                        </div>

                        {/* Dots do carrossel */}
                        <div className="config-modal--testimonial--carrossel-dots">
                            {Array.from(
                                { length: Math.min(this.state.depoimentos.length + 1, 5) },
                                (_, index) => (
                                    <span
                                        key={index}
                                        className={`dot ${this.state.currentDot === index ? 'active' : ''}`}
                                        onClick={() => {
                                            const depoimento = this.state.depoimentos[index];
                                            this.setState({
                                                currentDot: index,
                                                depoimentoAtual: {
                                                    texto: depoimento?.texto || '',
                                                    nome: depoimento?.nome || '',
                                                    cargo: depoimento?.cargo || ''
                                                }
                                            });
                                        }}
                                    />
                                )
                            )}
                        </div>
                    </div>

                </div>

                <div className="config-modal--login-right" >
                    <div className="carrossel-imagens">
                        <label className="config-modal--label">Carrossel de imagens (Dimensões: 708x708) </label>
                        <div
                            className="carrossel-imagens__imagem-vazia"
                            style={{
                                backgroundImage: `url(${addImage})`
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={this.handleDropImagem}
                        >
                            <div
                                className="carrossel-imagens__imagem"
                                style={{
                                    backgroundImage: this.state.imagens[this.state.currentImageDot]
                                        ? `url(${this.state.imagens[this.state.currentImageDot]})`
                                        : '', // fallback para imagem padrão do botão "+"
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    cursor: 'pointer'
                                }}>

                            </div>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={this.handleUploadImagem}
                                style={{ display: 'none' }}
                                ref={(ref) => (this.fileInputImagemRef = ref)}
                            />
                        </div>

                        <div style={{ display: 'flex', marginTop: '10px' }}>
                            <div className="config-modal--carousel-dots">
                                {Array.from({ length: Math.min(this.state.imagens.length + 1, 3) }, (_, index) => (
                                    <span
                                        key={index}
                                        className={`dot ${this.state.currentImageDot === index ? 'active' : ''}`}
                                        onClick={() => this.setState({ currentImageDot: index })}
                                    />
                                ))}
                            </div>

                            {this.state.imagens[this.state.currentImageDot] && (
                                <button
                                    className="config-modal--image-button-excluir"
                                    onClick={this.handleRemoverImagem}
                                >
                                    Remover
                                </button>
                            )}

                            {!this.state.imagens[this.state.currentImageDot] && (
                                <button
                                    className="config-modal--image-button"
                                    onClick={() => this.fileInputImagemRef.click()}
                                >
                                    Incluir
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="config-QrCode">
                        <div className="QrCode">
                            <label className="config-modal--label">Qr-Code</label>
                            <div
                                className="QrCode-vazia"
                                style={{
                                    backgroundImage: `url(${addQrCode})`
                                }}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={this.handleDropQrCode}
                            >
                                <div
                                    className="QrCode__imagem"
                                    style={{
                                        backgroundImage: this.state.QrCodeImage
                                            ? `url(${this.state.QrCodeImage})`
                                            : '',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        cursor: 'pointer'
                                    }}>
                                </div>


                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={this.handleUploadQrCode}
                                    style={{ display: 'none' }}
                                    ref={(ref) => (this.fileInputQrCodeRef = ref)}
                                />
                            </div>

                            <div className="QrCode--buttons">
                                {this.state.QrCodeImage ? (
                                    <button
                                        className="QrCode-button-excluir"
                                        onClick={this.handleRemoverQrCode}
                                    >
                                        Remover
                                    </button>
                                ) : (
                                    <button
                                        className="QrCode-button"
                                        onClick={() => this.fileInputQrCodeRef.click()}
                                    >
                                        Incluir
                                    </button>
                                )}
                            </div>

                        </div>
                        <div>
                            <div className="QrCode--input">
                                <label className="config-modal--label">Texto Qr-code</label>
                                <InputTextarea
                                    className="QrCode--input-text"
                                    placeholder="Escreva o texto de instrução ao uso do Qr-code"
                                    value={this.state.QrCodeText}
                                    onChange={(e) =>
                                        this.setState({
                                            QrCodeText: e.target.value
                                        })
                                    }
                                    autoResize={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderConfigExames() {

        return (
            <div className="config-modal--exams">

                <div className="config-exams--buttons-labels">
                    <div className="config-exams--left">
                        <label className="config-modal--label">Labels dos botões de imagem</label>
                        <div className="exams--image-buttons-labels">
                            <div className="image--viewer-button-label">
                                <label className="config-modal--label">Abrir viewer avançado</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnViewer}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnViewer: e.target.value
                                        })
                                    }

                                />
                            </div>
                            <div className="image--galery-button-label">
                                <label className="config-modal--label">Abrir a galeria de imagens</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnGaleria}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnGaleria: e.target.value
                                        })
                                    }

                                />
                            </div>
                            <div className="image--download-button-label">
                                <label className="config-modal--label">Baixar arquivos dicom</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnDownloadImagem}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnDownloadImagem: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="config-exams--left">
                        <label className="config-modal--label">Labels dos botões baixar imagem</label>
                        <div className="exams--image-buttons-labels">
                            <div className="image--viewer-button-label">
                                <label className="config-modal--label">Baixar com visualizador</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnDownloadVisualizador}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnDownloadVisualizador: e.target.value
                                        })
                                    }

                                />
                            </div>
                            <div className="image--galery-button-label">
                                <label className="config-modal--label">Baixar DICOM zip</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnDownloadDicomZip}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnDownloadDicomZip: e.target.value
                                        })
                                    }

                                />
                            </div>
                        </div>
                    </div>

                    <div className="config-exams--center">
                        <label className="config-modal--label">Labels dos botões de laudo</label>
                        <div className="exams--report-buttons-labels">
                            <div className="report--open-button-label">
                                <label className="config-modal--label">Abrir laudo</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnVisualizarLaudo}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnVisualizarLaudo: e.target.value
                                        })
                                    }
                                />

                            </div>
                            <div className="report--print-button-label">
                                <label className="config-modal--label">Abrir impressão de laudo</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnImprimirLaudo}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnImprimirLaudo: e.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="report--download-button-label">
                                <label className="config-modal--label">Baixar laudo em PDF</label>
                                <InputText
                                    className="config-modal--images-label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnDownloadLaudo}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnDownloadLaudo: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="config-exams--right">

                        <div className="exams--anexos-button-label">

                            <label className="config-modal--label">Label do botão de anexos</label>
                            <div className="anexos--open-button-label">
                                <label className="config-modal--label">Visualização de anexos</label>
                                <InputText
                                    className="config-modal--label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnVisualizarAnexos}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnVisualizarAnexos: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>


                        <div className="exams--parecer-button-label">
                            <label className="config-modal--label">Label do botão parecer médico</label>
                            <div className="parecer--open-button-label">
                                <label className="config-modal--label">Visualização de parecer</label>
                                <InputText
                                    className="config-modal--label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnVisualizarParecer}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnVisualizarParecer: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>


                        <div className="exams--parecer-button-label">
                            <label className="config-modal--label">Label do botão compartilhar</label>
                            <div className="parecer--open-button-label">
                                <label className="config-modal--label">Compartilhar exames</label>
                                <InputText
                                    className="config-modal--label-input"
                                    type="text"
                                    placeholder=""
                                    value={this.state.lblbtnCompartilhar}
                                    onChange={(e) =>
                                        this.setState({
                                            lblbtnCompartilhar: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <label className="config-modal--label">Informações do exame</label>
                <div className="config-exams--info-labels">

                    <div className="exams--info-labels-left">

                        <label className="config-modal--label">Ac. Number</label>
                        <div className="acnumber--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoAcNumber}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoAcNumber: e.target.value
                                    })
                                }
                            />
                        </div>

                        <label className="config-modal--label">Médico solicitante</label>
                        <div className="medico-solicitante--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoMedicoSol}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoMedicoSol: e.target.value
                                    })
                                }
                            />
                        </div>
                    </div>


                    <div className="exams--info-labels-center">

                        <label className="config-modal--label">Unidade</label>
                        <div className="unity--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoUnidade}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoUnidade: e.target.value
                                    })
                                }
                            />
                        </div>

                        <label className="config-modal--label">Médico executante</label>
                        <div className="medico-executante--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoMedicoExe}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoMedicoExe: e.target.value
                                    })
                                }
                            />
                        </div>
                    </div>

                    <div className="exams--info-labels-right">

                        <label className="config-modal--label">Data</label>
                        <div className="date--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoData}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoData: e.target.value
                                    })
                                }
                            />
                        </div>

                        <label className="config-modal--label">Médico executante</label>
                        <div className="medico-revisor--info-label">
                            <InputText
                                className="config-modal--label-input"
                                type="text"
                                placeholder=""
                                value={this.state.lblinfoMedicoRev}
                                onChange={(e) =>
                                    this.setState({
                                        lblinfoMedicoRev: e.target.value
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderConfigPaciente() {
        return (
            <div className="config-modal--pacient">
                <div className="config--patient-left">
                    <label className="config-modal--label">Botão imagens</label>
                    <div className="pacient--images-buttons">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnViewerAvancado_Paciente}
                                onChange={(e) => this.setState({ exibirbtnViewerAvancado_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnGaleria_Paciente}
                                onChange={(e) => this.setState({ exibirbtnGaleria_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Galeria de imagens</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Ação principal botão de imagens</label>
                    <div className="config-principal-actions-pacient">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalbtnimagem_Paciente === 'Viewer'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalbtnimagem_Paciente: e.value ? 'Viewer' : 'Galeria'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalbtnimagem_Paciente === 'Galeria'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalbtnimagem_Paciente: e.value ? 'Galeria' : 'Viewer'
                                    })
                                }
                            />
                            <label className="config--switch-label">Carregar galeria</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Ação ao clicar no preview</label>
                    <div className="config--action-preview-pacient">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalPreview_Paciente === 'Viewer'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalPreview_Paciente: e.value ? 'Viewer' : 'Galeria'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalPreview_Paciente === 'Galeria'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalPreview_Paciente: e.value ? 'Galeria' : 'Viewer'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir galeria</label>
                        </div>
                    </div>

                    <label className="config-modal--label"> Botões de baixar imagens</label>
                    <div className="pacient--button-download-images">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoBaixarImagens_visualizador_Paciente}
                                onChange={(e) => this.setState({ acaoBaixarImagens_visualizador_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Baixar pacote com visualizador</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoBaixarImagens_dicomZip_Paciente}
                                onChange={(e) => this.setState({ acaoBaixarImagens_dicomZip_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Baixar DICOM.zip</label>
                        </div>
                    </div>
                    
                </div>


                <div className="config--patient-center">

                    <label className="config-modal--label">Botão laudo</label>
                    <div className="pacient--report-buttons">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnVisualizarLaudo_Paciente}
                                onChange={(e) => this.setState({ exibirbtnVisualizarLaudo_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Visualizar laudo</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnImprimirLaudo_Paciente}
                                onChange={(e) => this.setState({ exibirbtnImprimirLaudo_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Imprimir Laudo</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Botões de compartilhamento</label>
                    <div className="pacient--individual-buttom">

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnCompartilhar_Paciente}
                                onChange={(e) => this.setState({ exibirbtnCompartilhar_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>
                    </div>                                

                    <label className="config-modal--label">Botão de anexos</label>
                    <div className="pacient--individual-buttom">

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnAnexos_Paciente}
                                onChange={(e) => this.setState({ exibirbtnAnexos_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>
                    </div>
                    <label className="config-modal--label">Inclusão de exames externos</label>
                    <div className="pacient--button-insert-exams">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnIncluirExames_Paciente}
                                onChange={(e) => this.setState({ exibirbtnIncluirExames_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Inclusão de exames</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.habilitarEnvioDICOM_ExamesExternos}
                                onChange={(e) => this.setState({ habilitarEnvioDICOM_ExamesExternos: e.value })}
                            />
                            <label className="config--switch-label">Envio de arquivos DICOM</label>
                        </div>
                    </div>   
                    <label className="config-modal--label">Pesquisa inicial dos exames</label>
                    <div className="pacient--button-insert-exams">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.pesquisa_Inicial_Exames_Paciente === 'Filtro'}
                                onChange={() =>
                                    this.setState({ pesquisa_Inicial_Exames_Paciente: 'Filtro' })
                                }
                            />
                            <label className="config--switch-label">Filtro inicial de 30 dias</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.pesquisa_Inicial_Exames_Paciente === 'Padrao'}
                                onChange={() =>
                                    this.setState({ pesquisa_Inicial_Exames_Paciente: 'Padrao' })
                                }
                            />
                            <label className="config--switch-label">Exibir todos os exames</label>
                        </div>
                    </div>
                </div>

                <div className="config--patient-right">

                    <label className="config-modal--label">Informações do exame</label>
                    <div className="pacient--exams-info">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoAcNumber_Paciente}
                                onChange={(e) => this.setState({ exibirInfoAcNumber_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Ac. number</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoProntuario_Paciente}
                                onChange={(e) => this.setState({ exibirInfoProntuario_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Prontuário</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoData_Paciente}
                                onChange={(e) => this.setState({ exibirInfoData_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Data</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoUnidade_Paciente}
                                onChange={(e) => this.setState({ exibirInfoUnidade_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Unidade</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoMedicoSol_Paciente}
                                onChange={(e) => this.setState({ exibirInfoMedicoSol_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Médico solicitante</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exbirInfoMedicoExe_Paciente}
                                onChange={(e) => this.setState({ exbirInfoMedicoExe_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Médico executante</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoMedicoRev_Paciente}
                                onChange={(e) => this.setState({ exibirInfoMedicoRev_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Médico revisor</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Status</label>
                    <div className="config--status">
                        <div className="config--switch" style={{ marginBottom: '20px' }}>
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirStatus_Paciente}
                                onChange={(e) => this.setState({ exibirStatus_Paciente: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>
                        <label className="config-modal--label">Em processamento</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusEmProcessamento_Paciente}
                            onChange={(e) =>
                                this.setState({
                                    statusEmProcessamento_Paciente: e.target.value
                                })
                            }
                        />

                        <label className="config-modal--label">Aguardando laudo</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusAguardandoLaudo_Paciente}
                            onChange={(e) =>
                                this.setState({
                                    statusAguardandoLaudo_Paciente: e.target.value
                                })
                            }
                        />

                        <label className="config-modal--label">Laudo liberado</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusLaudoLiberado_Paciente}
                            onChange={(e) =>
                                this.setState({
                                    statusLaudoLiberado_Paciente: e.target.value
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderConfigMedico() {

        return (
            <div className="config-modal--doctor">
                <div className="config--patient-left">
                    <label className="config-modal--label">Botão Imagens</label>
                    <div className="pacient--images-buttons">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnViewerAvancado_Medico}
                                onChange={(e) => this.setState({ exibirbtnViewerAvancado_Medico: e.value })}
                            />
                            <label className="config--switch-label">Viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnGaleria_Medico}
                                onChange={(e) => this.setState({ exibirbtnGaleria_Medico: e.value })}
                            />
                            <label className="config--switch-label">Galeria de imagens</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Ação principal botão de imagens</label>
                    <div className="config-principal-actions">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalbtnimagem_Medico === 'Viewer'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalbtnimagem_Medico: e.value ? 'Viewer' : 'Galeria'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalbtnimagem_Medico === 'Galeria'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalbtnimagem_Medico: e.value ? 'Galeria' : 'Viewer'
                                    })
                                }
                            />
                            <label className="config--switch-label">Carregar galeria</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Ação ao clicar no preview</label>
                    <div className="config--action-preview">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalPreview_Medico === 'Viewer'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalPreview_Medico: e.value ? 'Viewer' : 'Galeria'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir viewer avançado</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoPrincipalPreview_Medico === 'Galeria'}
                                onChange={(e) =>
                                    this.setState({
                                        acaoPrincipalPreview_Medico: e.value ? 'Galeria' : 'Viewer'
                                    })
                                }
                            />
                            <label className="config--switch-label">Abrir galeria</label>
                        </div>
                    </div>

                    <label className="config-modal--label"> Botões de baixar imagens</label>
                    <div className="pacient--button-download-images">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoBaixarImagens_visualizador_Medico}
                                onChange={(e) => this.setState({ acaoBaixarImagens_visualizador_Medico: e.value })}
                            />
                            <label className="config--switch-label">Baixar pacote com visualizador</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.acaoBaixarImagens_dicomZip_Medico}
                                onChange={(e) => this.setState({ acaoBaixarImagens_dicomZip_Medico: e.value })}
                            />
                            <label className="config--switch-label">Baixar DICOM.zip</label>
                        </div>
                    </div>                    
                </div>


                <div className="config--patient-center">                  

                    {/*Esta opção está indisponível para o perfil médico*/}                    
                    {/*<label className="config-modal--label">Botão incluir exames</label>*/}
                    {/*<div className="pacient--button-insert-exams">*/}
                    {/*    <div className="config--switch">*/}
                    {/*        <InputSwitch*/}
                    {/*            className="switch"*/}
                    {/*            className="switch"*/}
                    {/*            checked={this.state.exibirbtnIncluirExames_Medico}*/}
                    {/*            onChange={(e) => this.setState({ exibirbtnIncluirExames_Medico: e.value })}*/}
                    {/*        />*/}
                    {/*        <label className="config--switch-label">Visível</label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <label className="config-modal--label">Botão laudo</label>
                    <div className="pacient--report-buttons">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnVisualizarLaudo_Medico}
                                onChange={(e) => this.setState({ exibirbtnVisualizarLaudo_Medico: e.value })}
                            />
                            <label className="config--switch-label">Visualizar laudo</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnImprimirLaudo_Medico}
                                onChange={(e) => this.setState({ exibirbtnImprimirLaudo_Medico: e.value })}
                            />
                            <label className="config--switch-label">Imprimir Laudo</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Botões de compartilhamento</label>
                    <div className="pacient--individual-buttom">

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnCompartilhar_Medico}
                                onChange={(e) => this.setState({ exibirbtnCompartilhar_Medico: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>


                    </div>

                    <label className="config-modal--label">Botão de anexos</label>
                    <div className="pacient--individual-buttom">

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirbtnAnexos_Medico}
                                onChange={(e) => this.setState({ exibirbtnAnexos_Medico: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>


                    </div>

                    <label className="config-modal--label">Botão de parecer médico</label>
                    <div className="pacient--individual-buttom">

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exbibirbtnParecerMedico_Medico}
                                onChange={(e) => this.setState({ exbibirbtnParecerMedico_Medico: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>

                    </div>

                    <label className="config-modal--label">Exames externos</label>
                    <div className="pacient--individual-buttom">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.pesquisaExamesExternosAtiva_Medico}
                                onChange={(e) => this.setState({ pesquisaExamesExternosAtiva_Medico: e.value })}
                            />
                            <label className="config--switch-label">Pesquisa exames externos ativo</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Pesquisa</label>
                    <div className="pacient--search-dias">
                        <label className="config--field-hint">
                            Dias retroativos exibidos na pesquisa inicial de exames ao logar
                        </label>
                        <InputNumber
                            className="config--input-number"
                            inputClassName="config--dias-input"
                            value={this.state.diasPesquisaInicialAoLogar_Medico}
                            onValueChange={(e) => this.setState({ diasPesquisaInicialAoLogar_Medico: e.value ?? 0 })}
                            mode="decimal"
                            integerOnly
                            min={0}
                            max={365}
                            step={1}
                            showButtons
                            buttonLayout="horizontal"
                            incrementButtonIcon="pi pi-angle-up"
                            decrementButtonIcon="pi pi-angle-down"
                            useGrouping={false}
                        />
                    </div>
                </div>

                <div className="config--patient-right">

                    <label className="config-modal--label">Informações do exame</label>
                    <div className="pacient--exams-info">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoAcNumber_Medico}
                                onChange={(e) => this.setState({ exibirInfoAcNumber_Medico: e.value })}
                            />
                            <label className="config--switch-label">Ac. number</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoProntuario_Medico}
                                onChange={(e) => this.setState({ exibirInfoProntuario_Medico: e.value })}
                            />
                            <label className="config--switch-label">Prontuário</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoData_Medico}
                                onChange={(e) => this.setState({ exibirInfoData_Medico: e.value })}
                            />
                            <label className="config--switch-label">Data</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoUnidade_Medico}
                                onChange={(e) => this.setState({ exibirInfoUnidade_Medico: e.value })}
                            />
                            <label className="config--switch-label">Unidade</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoMedicoSol_Medico}
                                onChange={(e) => this.setState({ exibirInfoMedicoSol_Medico: e.value })}
                            />
                            <label className="config--switch-label">Médico solicitante</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exbirInfoMedicoExe_Medico}
                                onChange={(e) => this.setState({ exbirInfoMedicoExe_Medico: e.value })}
                            />
                            <label className="config--switch-label">Médico executante</label>
                        </div>
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirInfoMedicoRev_Medico}
                                onChange={(e) => this.setState({ exibirInfoMedicoRev_Medico: e.value })}
                            />
                            <label className="config--switch-label">Médico revisor</label>
                        </div>
                    </div>

                    <label className="config-modal--label">Status</label>
                    <div className="config--status">
                        <div className="config--switch" style={{ marginBottom: '20px' }}>
                            <InputSwitch
                                className="switch"
                                checked={this.state.exibirStatus_Medico}
                                onChange={(e) => this.setState({ exibirStatus_Medico: e.value })}
                            />
                            <label className="config--switch-label">Visível</label>
                        </div>
                        <label className="config-modal--label">Em processamento</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusEmProcessamento_Medico}
                            onChange={(e) =>
                                this.setState({
                                    statusEmProcessamento_Medico: e.target.value
                                })
                            }
                        />

                        <label className="config-modal--label">Aguardando laudo</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusAguardandoLaudo_Medico}
                            onChange={(e) =>
                                this.setState({
                                    statusAguardandoLaudo_Medico: e.target.value
                                })
                            }
                        />

                        <label className="config-modal--label">Laudo liberado</label>
                        <InputText
                            className="config-modal--label-input"
                            type="text"
                            placeholder=""
                            value={this.state.statusLaudoLiberado_Medico}
                            onChange={(e) =>
                                this.setState({
                                    statusLaudoLiberado_Medico: e.target.value
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderConfigGeral() {

        const temopoInatividaede = [
            { label: '15 minutos', value: 0 },
            { label: '30 minutos', value: 1 },
            { label: '45 minutos', value: 2 },
            { label: '1 hora', value: 3 }
        ];

        const formadeEnvioItems = [
            { label: 'Email', value: 'EMAIL' },
        ];

        const criptografiaItems = [
            { label: 'SSL', value: 'SSL' },
            { label: 'TLS', value: 'TLS' },
        ];

        const validadeSenhaItens = [
            { label: '8h', value: '8' },
            { label: '12h', value: '12' },
            { label: '24h', value: '24' },
            { label: '48h', value: '48' },
        ];



        // Função auxiliar
        function base64ToString(base64) {
            try {
                return atob(base64);
            } catch (e) {
                console.error("Erro ao decodificar Base64:", e);
                return base64; // fallback: devolve cru
            }
        }

        function stringToBase64(str) {
            try {
                return btoa(str);
            } catch (e) {
                console.error("Erro ao converter para Base64:", e);
                return str;
            }
        }

        return (
            <div className="config-modal--general">

                <div className="general--image-service">
                    <dvi className="general--image-service-input">
                        <label className="config-modal--label">Serviço de imagem</label>
                        <InputText
                            className="config--input-text"
                            type="text"
                            placeholder=""
                            value={this.state.servicoDeImagem}
                            onChange={(e) =>
                                this.setState({
                                    servicoDeImagem: e.target.value
                                })
                            }
                        />
                    </dvi>

                    <div style={{ width: "20%", marginRight: '20px' }}>
                        <label className="config-modal--label">Tempo de inatividade</label>
                        <Dropdown
                            className="config-dropdown"
                            value={this.state.tempoInatividade}
                            options={temopoInatividaede}
                            onChange={(e) => { this.setState({ tempoInatividade: e.value }) }}
                        />
                    </div>

                    <div className="general--switches">
                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.linkPortalProntuario}
                                onChange={(e) => this.setState({ linkPortalProntuario: e.value })}
                            />
                            <label className="config--switch-label">Link do portal por prontuário</label>
                        </div>

                        <div className="config--switch">
                            <InputSwitch
                                className="switch"
                                checked={this.state.autenticacaoDoisFatores}
                                onChange={(e) => this.setState({ autenticacaoDoisFatores: e.value })}
                            />
                            <label className="config--switch-label">Autenticação em dois fatores</label>
                        </div>

                        {this.state.exibir_apenas_pedidos_revisados_portal !== null && (
                            <div className="config--switch">
                                <InputSwitch
                                    className="switch"
                                    checked={this.state.exibir_apenas_pedidos_revisados_portal}
                                    onChange={(e) => this.setState({ exibir_apenas_pedidos_revisados_portal: e.value })}
                                />
                                <label className="config--switch-label">Exibir apenas pedidos revisados</label>
                            </div>
                        )}
                    </div>
                </div>

                <div className="general--image-service">




                    {/*<div style={{ width: "40%" }}>*/}
                    {/*    <label className="config-modal--label">Cor padrão do sistema</label>*/}
                    {/*    <div className="config--default-color">*/}
                    {/*        <div className="default-color">*/}
                    {/*            <ColorPicker*/}
                    {/*                className="color-picker"*/}
                    {/*                format="hex"*/}
                    {/*                value={this.state.defaultColor}*/}
                    {/*                onChange={(e) => this.setState({ defaultColor: e.value })}*/}
                    {/*            />*/}
                    {/*            <div>*/}
                    {/*                <label className="config--switch-label">Principal</label>*/}
                    {/*                <InputText*/}
                    {/*                    className="config--input-color"*/}
                    {/*                    type="text"*/}
                    {/*                    placeholder=""*/}
                    {/*                    value={this.state.defaultColor}*/}
                    {/*                    onChange={(e) =>*/}
                    {/*                        this.setState({*/}
                    {/*                            defaultColor: e.target.value*/}
                    {/*                        })*/}
                    {/*                    }*/}
                    {/*                />*/}
                    {/*            </div>*/}

                    {/*        </div>*/}
                    {/*        <div className="default-color">*/}
                    {/*            <ColorPicker*/}
                    {/*                className="color-picker"*/}
                    {/*                format="hex"*/}
                    {/*                value={this.state.secondaryColor}*/}
                    {/*                onChange={(e) => this.setState({ secondaryColor: e.value })}*/}
                    {/*            />*/}
                    {/*            <div>*/}
                    {/*                <label className="config--switch-label">Secundária</label>*/}
                    {/*                <InputText*/}
                    {/*                    className="config--input-color"*/}
                    {/*                    type="text"*/}
                    {/*                    placeholder=""*/}
                    {/*                    value={this.state.secondaryColor}*/}
                    {/*                    onChange={(e) =>*/}
                    {/*                        this.setState({*/}
                    {/*                            secondaryColor: e.target.value*/}
                    {/*                        })*/}
                    {/*                    }*/}
                    {/*                />*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>



                <div className="general--config">
                    <div className="general--config-email">
                        <div style={{ width: "33%", marginRight: '20px' }}>
                            <label className="config-modal--label">Forma de envio</label>
                            <Dropdown
                                className="config-dropdown"
                                type="text"
                                label={this.state.formaDeEnvio}
                                value={this.state.formaDeEnvio}
                                options={formadeEnvioItems}
                                onChange={(e) => { this.setState({ formaDeEnvio: e.value }) }}
                            />
                        </div>

                        <div style={{ width: "33%", marginRight: '20px' }}>
                            <label className="config-modal--label">Criptografia</label>
                            <Dropdown
                                className="config-dropdown"
                                type="text"
                                label={this.state.criptografica}
                                value={this.state.criptografica}
                                options={criptografiaItems}
                                onChange={(e) => { this.setState({ criptografica: e.value }) }}
                            />
                        </div>

                        <div style={{ width: "33%" }}>
                            <label className="config-modal--label">Validade senha</label>
                            <Dropdown
                                className="config-dropdown"
                                type="text"
                                label={this.state.validadeSenha}
                                value={this.state.validadeSenha}
                                options={validadeSenhaItens}
                                onChange={(e) => { this.setState({ validadeSenha: e.value }) }}
                            />
                        </div>
                    </div>

                    <div className="general--config--email-service">
                        <div style={{ width: "25%", marginRight: '20px' }}>
                            <label className="config-modal--label">SMTP</label>
                            <InputText
                                className="config--input-text"
                                type="text"
                                placeholder=""
                                value={this.state.SMTP}
                                onChange={(e) =>
                                    this.setState({
                                        SMTP: e.target.value
                                    })
                                }
                            />
                        </div>

                        <div style={{ width: "25%", marginRight: '20px' }}>
                            <label className="config-modal--label">E-mail</label>
                            <InputText
                                className="config--input-text"
                                type="text"
                                placeholder=""
                                value={this.state.email}
                                onChange={(e) =>
                                    this.setState({
                                        email: e.target.value
                                    })
                                }
                            />
                        </div>

                        <div style={{ width: "25%", marginRight: '20px' }}>
                            <label className="config-modal--label">Senha</label>
                            <InputText
                                className="config--input-text"
                                type="password"
                                placeholder=""
                                defaultValue={this.state.temSenha}
                                ref={(el) => this.inputSenhaRef = el}
                                onChange={(e) => this.salvarSenha(e.target.value)}
                            />
                        </div>


                        <div style={{ width: "25%", marginRight: '20px' }}>
                            <label className="config-modal--label">Porta</label>
                            <InputText
                                className="config--input-text"
                                type="text"
                                placeholder=""
                                value={this.state.porta}
                                onChange={(e) =>
                                    this.setState({
                                        porta: e.target.value
                                    })
                                }
                            />
                        </div>
                    </div>

                    <div className="general--config--email-layout">
                        <div className="config-layout-email">
                            <label className="config-modal--label">Layout e-mail</label>
                            <ReactQuill
                                theme="snow"
                                value={base64ToString(this.state.conteudoEmail)}
                                onChange={(html) =>
                                    this.setState({ conteudoEmail: stringToBase64(html) })
                                }
                                className="ql-editor-custom"
                                placeholder="Digite o conteúdo do layout do e-mail..."
                            />
                        </div>

                        <div className="config-layout-email">
                            <label className="config-modal--label">Mensagem e-mail não cadastrado</label>
                            <ReactQuill
                                theme="snow"
                                value={base64ToString(this.state.mensagemNaoCadastrado)}
                                onChange={(html) =>
                                    this.setState({ mensagemNaoCadastrado: stringToBase64(html) })
                                }
                                className="ql-editor-custom"
                                placeholder="Mensagem exibida quando o e-mail não estiver cadastrado..."
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    salvarSenha(value) {

        const trimmed = value.trim();

        if (/^\.+$/.test(trimmed)) {
            if (this.inputSenhaRef) {
                this.inputSenhaRef.value = "";
            }

            this.setState({
                temSenha: "", 
                senha: ""    
            });

            return;
        }

        if (trimmed === "") {
            return;
        }

        if (trimmed === this.state.temSenha) {
            return;
        }

        this.setState({
            senha: trimmed
        });
    }




    renderConfigContent() {
        const renderMap = {
            login: this.renderConfigLogin,
            exames: this.renderConfigExames,
            paciente: this.renderConfigPaciente,
            medico: this.renderConfigMedico,
            geral: this.renderConfigGeral
        };

        const RenderComponent = renderMap[this.state.configuracaoSelecionada];

        return (
            <div className="config-modal__content">
                {RenderComponent && RenderComponent.call(this)}
            </div>
        );
    }

    renderConfigFooter() {
        return (
            <div className="config-modal__footer">
                <button
                    className="config-modal__footer-cancelar p-button p-component"
                    onClick={() => window.location.reload()}
                >
                    Cancelar
                </button>

                <button
                    className="config-modal__footer-salvar p-button p-component"
                    onClick={async () => {
                        await this.handleSalvarConfig();
                        await this.handleSalvarConfigDB();
                        this.setState({ showSuccessModal: true });
                    }}
                >
                    Salvar
                </button>

                <Dialog
                    visible={this.state.showSuccessModal}
                    onHide={() => this.setState({ showSuccessModal: false })}
                    className="config--success-modal"
                >
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <i className="pi pi-check-circle" style={{ fontSize: "2rem", color: "green" }} />
                        <p style={{ marginTop: "15px" }}>Alterações salvas com sucesso!</p>
                    </div>
                </Dialog>
            </div>

        );
    }

    render() {

        return (
            <div className="config-page">
                {/* Header (menu de navegação) */}
                <div className="config-page__header">
                    {this.renderConfigHeader()}
                </div>

                {/* Conteúdo dinâmico */}
                <div className="config-page__content">
                    {this.renderConfigContent()}
                </div>

                {/* Footer (ações) */}
                <div className="config-page__footer">
                    {this.renderConfigFooter()}
                </div>
            </div>

        );
    }
}

export default ScreensConfig;
